import { defineStyle } from '@chakra-ui/react';

const theme = defineStyle({
  root: {
    display: 'flex',
    flexDirection: { base: 'column', lg: 'row' },
    minH: '100vh',
  },
  contentSide: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: { base: '40px 24px', lg: '80px 60px' },
  },
  formSide: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: { base: '40px 24px', lg: '80px 60px' },
    backgroundColor: 'background',
  },
});

export default theme;
